import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/icon/variants/IconPayments.tsx
const OutlinedFilledPayments = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M111-137q-38.78 0-66.39-27.61T17-231v-449h94v449h689v94H111Zm144-143q-39.73 0-67.36-27.64Q160-335.27 160-375v-376q0-39.19 27.64-67.09Q215.27-846 255-846h594q38.77 0 66.39 27.91Q943-790.19 943-751v376q0 39.73-27.61 67.36Q887.77-280 849-280H255Zm88-83q0-42-29-71t-71-29v100h100Zm417 0h100v-100q-42 0-71 29t-29 71Zm-209-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM243-663q42 0 71-29.5t29-70.5H243v100Zm617 0v-100H760q0 41 29 70.5t71 29.5Z" })
});
const OutlinedPayments = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M551-443q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM255-280q-39.73 0-67.36-27.64Q160-335.27 160-375v-376q0-39.19 27.64-67.09Q215.27-846 255-846h594q38.77 0 66.39 27.91Q943-790.19 943-751v376q0 39.73-27.61 67.36Q887.77-280 849-280H255Zm88-83h417q0-42 29-71t71-29v-200q-42 0-71-29.5T760-763H343q0 41-29 70.5T243-663v200q42 0 71 29t29 71Zm457 226H111q-38.78 0-66.39-27.61T17-231v-449h94v449h689v94ZM243-363v-400 400Z" })
});
const RoundedFilledPayments = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M111-137q-38.78 0-66.39-27.61T17-231v-402q0-19.75 13.68-33.38Q44.35-680 64.18-680 84-680 97.5-666.38 111-652.75 111-633v402h642q19.75 0 33.38 13.68Q800-203.65 800-183.82q0 19.82-13.62 33.32Q772.75-137 753-137H111Zm144-143q-39.73 0-67.36-27.64Q160-335.27 160-375v-376q0-39.19 27.64-67.09Q215.27-846 255-846h594q38.77 0 66.39 27.91Q943-790.19 943-751v376q0 39.73-27.61 67.36Q887.77-280 849-280H255Zm88-83q0-42-29-71t-71-29v100h100Zm417 0h100v-100q-42 0-71 29t-29 71Zm-209-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM243-663q42 0 71-29.5t29-70.5H243v100Zm617 0v-100H760q0 41 29 70.5t71 29.5Z" })
});
const RoundedPayments = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M551-443q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM255-280q-39.73 0-67.36-27.64Q160-335.27 160-375v-376q0-39.19 27.64-67.09Q215.27-846 255-846h594q38.77 0 66.39 27.91Q943-790.19 943-751v376q0 39.73-27.61 67.36Q887.77-280 849-280H255Zm88-83h417q0-42 29-71t71-29v-200q-42 0-71-29.5T760-763H343q0 41-29 70.5T243-663v200q42 0 71 29t29 71Zm410 226H111q-38.78 0-66.39-27.61T17-231v-402q0-19.75 13.68-33.38Q44.35-680 64.18-680 84-680 97.5-666.38 111-652.75 111-633v402h642q19.75 0 33.38 13.68Q800-203.65 800-183.82q0 19.82-13.62 33.32Q772.75-137 753-137ZM243-363v-400 400Z" })
});
const SharpFilledPayments = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M17-137v-543h94v449h689v94H17Zm143-143v-566h783v566H160Zm183-83q0-42-29-71t-71-29v100h100Zm417 0h100v-100q-42 0-71 29t-29 71Zm-209-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM243-663q42 0 71-29.5t29-70.5H243v100Zm617 0v-100H760q0 41 29 70.5t71 29.5Z" })
});
const SharpPayments = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M551-443q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM160-280v-566h783v566H160Zm183-83h417q0-42 29-71t71-29v-200q-42 0-71-29.5T760-763H343q0 41-29 70.5T243-663v200q42 0 71 29t29 71ZM17-137v-543h94v449h689v94H17Zm226-226v-400 400Z" })
});
const componentMap = {
	outlined: OutlinedPayments,
	"outlined-fill": OutlinedFilledPayments,
	rounded: RoundedPayments,
	"rounded-fill": RoundedFilledPayments,
	sharp: SharpPayments,
	"sharp-fill": SharpFilledPayments
};
const IconPayments = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Icon, {
		alt: "",
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconPayments };